import { render, staticRenderFns } from "./UserLockDialog.vue?vue&type=template&id=274cc6c8&scoped=true&"
import script from "./UserLockDialog.vue?vue&type=script&lang=js&"
export * from "./UserLockDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserLockDialog.vue?vue&type=style&index=0&id=274cc6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274cc6c8",
  null
  
)

export default component.exports